<script setup>
  defineProps({
    name: {
      type: String,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <span :class="outlined ? 'material-icons-outlined' : 'material-icons'">
    {{ name }}
  </span>
</template>
